import { render, staticRenderFns } from "./showCode.vue?vue&type=template&id=638db67a&"
import script from "./showCode.vue?vue&type=script&lang=js&"
export * from "./showCode.vue?vue&type=script&lang=js&"
import style0 from "./showCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports